
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import CommonLink from '@Components/common/Link';
import ProfileLayout from '@Components/Layout/profile';
import { Wrapper } from '@Components/ProfilePage/ProfilePage.styled';
import { Info, Link, P, Title } from '@Components/TermsAndConditions/TermsAndConditions.styled';
import useTranslation from 'next-translate/useTranslation';

type Props = {};

const AboutUs = ({}: Props) => {
  const { t } = useTranslation('common');
  return (
    <ProfileLayout seoData={{ title: t('about') }} hideSideBar={true}>
      <Wrapper>
        <div dir="auto">
          <Title>عن يورباريتس</Title>
          <Info>من نحن</Info>
          <P>يورباريتس هوا أكبر سوق الكتروني في مصر لكل ما تحتاجه سيارتك </P>
          <P>
            وتستطيع من خلال موقعنا شراء قطع غيار أصلية مع الحصول على ضمان يصل إلى 6 أشهر وأيضاً يمكنكم شراء الإطارات
            والجنوط وأي كماليات خاصة بسيارتك.
          </P>
          <P>
            ويمكنك أن تطلب خدمة التركيب لأي قطعة غيار أو إجراء أي فحص أو جدولة صيانة سيارتك من خلال شريكنا يورفكسرز الذي
            سيقدم لكم هذه الخدمة أسفل المنزل.
          </P>
          <P>
            ذلك استطعنا تحقيق المعادلة الأصعب بربط مراكز الصيانة ومراكز بيع قطع الغيار مع العميل وهو في مكانه مما يعني
            توفير الوقت والمال لعملائنا.{' '}
          </P>
          <P>
            {' '}
            ولن تحتاج بعد الآن أن تأخذ من وقت عملك أو يومك للبحث عن ما يلزم لصيانة سيارتك أو إصلاح التالف بها لأننا نقدم
            هذه الخدمة بجودة عالية بأنسب سعر..
          </P>
          <Title>عنوان الادارة : </Title>
          <Title>B3 برج الريحانة</Title>
          <Title>زهراء المعادي - سرايات الغربية</Title>
          <Title>الدور الرابع</Title>
          <Link href="https://goo.gl/maps/yCsUpXw2rkNazmAQA" target="_blank" rel="noreferrer noopener">
            https://goo.gl/maps/yCsUpXw2rkNazmAQA
          </Link>
          <Info>تواصل معنا</Info>
          <Title>اذا كان لديك اي اسئلة بخصوص سياستنا يمكنك التواصل معنا عبر </Title>
          <P>
            البريد الاكتروني : <Link href="mailto:info@yourparts.com">info@yourparts.com</Link>
          </P>
          <P>
            زيارة صفحتنا{' '}
            <Link as={CommonLink} href="/contact">
              <span>yourparts.com/contact</span>
            </Link>
          </P>
          <P>
            الخط الساخن :{' '}
            <Link href="tel:15145">
              <span>15145</span>
            </Link>
          </P>
        </div>
      </Wrapper>
    </ProfileLayout>
  );
};

 async function _getStaticProps() {
  return {
    props: {},
  };
}

export default AboutUs;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/about',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  